export default "__VITE_ASSET__CrQK80D6__"